module.exports = __webpack_public_path__ + "fonts/CamingoDos-Pro-ExtraLight.ttf";